import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { ItemsAdBlock } from "../../../../api/packbo/models/items-ad-block";
import { ItemsCertifications } from "../../../../api/packbo/models/items-certifications";
import { ItemsHeaderBlock } from "../../../../api/packbo/models/items-header-block";
import { ItemsSuppliers } from "../../../../api/packbo/models/items-suppliers";

type SearchResultsState = {
    loading: boolean;
    supplierImagesLoading: boolean;
    suppliers: ItemsSuppliers[];
    adBlock: ItemsAdBlock | null;
    headerBlock: ItemsHeaderBlock | null;
    itemsCertifications: ItemsCertifications[];
    isEcoFriendly: boolean | null;
    pagination: {
        currentPage: number;
        totalPages: number;
        itemsPerPage: number;
    };
};

const initialState: SearchResultsState = {
    loading: false,
    supplierImagesLoading: true,
    suppliers: [],
    adBlock: null,
    headerBlock: null,
    itemsCertifications: [],
    isEcoFriendly: null,
    pagination: {
        currentPage: 1,
        totalPages: 1,
        itemsPerPage: 48
    }
};

export const SearchResultsStore = signalStore(
    withState(initialState),
    withMethods((store) => ({
        setLoading(loading: boolean) {
            patchState(store, { loading });
        },
        setSupplierImagesLoading(supplierImagesLoading: boolean) {
            patchState(store, { supplierImagesLoading });
        },
        setSuppliers(suppliers: ItemsSuppliers[]) {
            patchState(store, { suppliers });
        },
        setAdBlock(adBlock: ItemsAdBlock | null) {
            patchState(store, { adBlock });
        },
        setHeaderBlock(headerBlock: ItemsHeaderBlock | null) {
            patchState(store, { headerBlock });
        },
        setItemsCertifications(itemsCertifications: ItemsCertifications[]) {
            patchState(store, { itemsCertifications });
        },
        setIsEcoFriendly(isEcoFriendly: boolean | null) {
            patchState(store, { isEcoFriendly });
        },
        setPagination(pagination: Partial<SearchResultsState["pagination"]>) {
            patchState(store, {
                pagination: { ...store.pagination(), ...pagination }
            });
        },
        resetPagination() {
            patchState(store, {
                pagination: {
                    currentPage: 1,
                    totalPages: 1,
                    itemsPerPage: 48
                }
            });
        }
    }))
);
